import * as _ from 'lodash';
import { Pipe, PipeTransform } from '@angular/core';
import { Action } from '../components/pages/landing-page/landing-page.component';

@Pipe({
  name: 'activeAction',
})
export class ActiveActionPipe implements PipeTransform {
  transform(actions: Action[], ...args: unknown[]): Action {
    return _.find(actions, ['data.active', true]);
  }
}
